import { render, staticRenderFns } from "./RegisterTable.vue?vue&type=template&id=bbe38928&scoped=true"
import script from "./RegisterTable.vue?vue&type=script&lang=js"
export * from "./RegisterTable.vue?vue&type=script&lang=js"
import style0 from "./RegisterTable.vue?vue&type=style&index=0&id=bbe38928&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe38928",
  null
  
)

export default component.exports